import Guid from '@/app/utils/guid'
import NodeEntity from '@/common/models/node-entitiy'
import moment from 'moment'

export default class Action extends NodeEntity {

  // public groupId = Guid.empty()
  public description: string = ''
  public begin: string = moment().format('YYYY-MM-DD')
  public end: string = moment().format('YYYY-MM-DD')
  public phase: number = 0
  // A phase can have n lanes.
  public lane: number = 0
  public isMilestone: boolean = false
  public groups: string[] = []
  public order = 0
}
